import arrow_out_blue from 'images2/inclusione/arrow_out_blue.svg';
import { PAGE_INCLUSIONE_APPRENDIMENTO_ITALIANO } from 'types/url';

//CercoOffroScuola
export const cercoOffroScuolaTitle = "cerco-offro scuola";
//CosaOffre
export const cosaOffre = {
  title: "cosa offre",
  content: [
    {
      subTitle: "INFORMAZIONI",
      text: "Per conoscere meglio il sistema scolastico italiano e capire quali documenti sono necessari per l’inserimento a scuola."
    },
    {
      subTitle: "ORIENTAMENTO SCOLASTICO",
      text: "Per avere una consulenza specialistica nella scelta della scuola superiore milanese personalizzato sui bisogni espressi dalle ragazze, i ragazzi e le loro famiglie."
    },
    {
      subTitle: "ORIENTAMENTO EXTRA-SCOLASTICO",
      text: "Per individuare le risorse di attività ricreative, sportive, culturali e di socializzazione presenti in città."
    },
    {
      subTitle: "ORIENTAMENTO ALL’UNIVERSITÀ",
      text: "Per conoscere le facoltà universitarie presenti a Milano e capire se si hanno i requisiti necessari per accedervi."
    },
    {
      subTitle: "ACCOMPAGNAMENTO ALL’ISCRIZIONE",
      text: "Per ricevere supporto all’iscrizione nelle scuole, nelle università e nelle attività extra-scolastiche scelte."
    },
    {
      subTitle: "ATTIVITÀ DI GRUPPO",
      text: "Per conoscere altri ragazzi e ragazze neo-arrivati a Milano e condividere con loro emozioni e aspettative, scoprendo insieme la città e i suoi servizi."
    },
    {
      subTitle: "MEDIAZIONE LINGUISTICO-CULTURALE",
      text: "Per favorire la comprensione e la comunicazione con i ragazzi, le ragazze e le loro famiglie attraverso la mediazione linguistica e culturale di operatori specializzati."
    },
    {
      subTitle: "APPRENDIMENTO DELLA LINGUA ITALIANA",
      text: "Per ricevere informazioni e orientamento sui corsi per l’apprendimento della lingua italiana offerti da istituzioni, scuole e associazioni.",
      faicon: arrow_out_blue,
      color: "blue",
      src: PAGE_INCLUSIONE_APPRENDIMENTO_ITALIANO
    }
  ],
};
//AChiERivolto
export const aChiERivolto = {
  title: "A chi è rivolto",
  content: [
    {
      subTitle: "Ai cittadini",
      text: "Ai ragazzi e le ragazze dai 14 ai 21 anni, arrivati da altri paesi in Italia da meno di tre anni."
    },
    {
      subTitle: "Alle scuole",
      text: "Agli istituti scolastici secondari superiori milanesi che possono segnalare al servizio ragazzi e ragazze arrivati in Italia da altri paesi che necessitano di orientamento alla scelta."
    }
  ]
};
//ConChiCollabora
export const conChiCollabora = {
  title: "con chi collabora",
  list: [
    "Servizi scolastici educativi territoriali",
    "Ufficio Scolastico Territoriale e Istituzioni Scolastiche di ogni ordine e grado",
    "Poli START",
    "ATS",
    "Rappresentanze Consolari",
    "Enti del Terzo Settore e rete territoriale dei Servizi Sociali",
  ],
  button: "ho bisogno di orientamento"
};

export const ANCHOR_TOP = "top-page";